module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    staticClass: "chap",
    attrs: {
      "epub:type": "chapter",
      "id": "chap-002"
    }
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_25",
      "title": "25"
    }
  }), _c('div', {
    staticClass: "chap_debut"
  }), _vm._v(" "), _c('h1', {
    staticClass: "chap_n",
    attrs: {
      "epub:type": "title"
    }
  }, [_c('span', [_vm._v("Chapter Two")])]), _vm._v(" "), _c('h1', {
    staticClass: "chap_tit",
    attrs: {
      "epub:type": "title"
    }
  }, [_c('span', [_vm._v("Playing the harlot")])]), _vm._v(" "), _c('div', {
    staticClass: "dev"
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("For post-fall humanity, adulterated by sin, the Bible unfolds the drama of a loving God winning back to himself ‘a pure bride for her one husband’ (2 Cor. 11:2). Human marriage as original and ideal, defined in Genesis 2:23-24, provides the pre-understanding necessary for spiritual ‘harlotry’ to function as a meaningful moral category in the covenanted people’s perception of themselves and of their ‘marital’ obligations to their Lord, until the biblical drama reaches its eventual dénouement.")]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("As the Old Testament unfolds, one first encounters only intimations of Yahweh’s marriage to his people. Such a relation-ship seems to have been assumed rather than declared, for Yahweh is explicitly identified as the ‘husband’ of Israel nowhere previous to the prophets."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/Text/appen10#NFIN28",
      "id": "ap_NFIN28-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1")])]), _vm._v(" Nevertheless, language suggestive of a marital bond is used of the covenant at the literary foundation of the Old Testament."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/Text/appen10#NFIN29",
      "id": "ap_NFIN29-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2")])])]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("My approach in tracking the linguistic markers of our theme is exegetical and not merely lexicographical, however. Out of "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_26",
      "title": "26"
    }
  }), _vm._v("Israel’s overall vision of God as King, Judge, Shepherd, Husband, and so on, an author would choose specific language for use in any given context as it was apt to evoke that particular aspect of God’s ultimate meaning most congenial with the author’s theological purpose in that passage. For this reason, I will not appeal to the usage of "), _c('span', {
    staticClass: "mev1"
  }, [_vm._v("√")]), _c('i', [_vm._v("znh")]), _vm._v(" (BDB ‘commit fornication, be a harlot’)"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/Text/appen10#NFIN30",
      "id": "ap_NFIN30-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3")])]), _vm._v(" as my fundamental theological datum. Rather, through exegesis of the passages in which this language appears one is able to re-create the larger theological imagination which itself prompted the use of such language to begin with. The following proposals, therefore, grounded in exegesis, open up the nexus of meanings informed by the idea that the bond between Yahweh and Israel is marital in nature. In the Pentateuch and historical books, the indicators of this deeper theological substructure underlying the text are found in the references to Israel’s whoredom in sharing her worship with other gods and in Yahweh’s jealousy for her."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/Text/appen10#NFIN31",
      "id": "ap_NFIN31-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4")])]), _vm._v(" Our primary interest here lies in the former.")]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("The donor conceptual field of marriage prescribes strict sexual faithfulness between husband and wife. Illegitimate sexual involvement, the dark reversal of the marital ideal, exposes the brokenness of a fallen race. The word group related to "), _c('span', {
    staticClass: "mev1"
  }, [_vm._v("√")]), _c('i', [_vm._v("znh")]), _vm._v(" is used literally of such unlawful sexual activity, "), _c('i', [_vm._v("e.g.")]), _vm._v(" Tamar’s apparent prostitution in Genesis 38:24, as well as figuratively for betrayal"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/Text/appen10#NFIN32",
      "id": "ap_NFIN32-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5")])]), _vm._v(" of one’s union with God.")]), _vm._v(" "), _c('div', {
    staticClass: "niv1",
    attrs: {
      "id": "niv1-001"
    }
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_27",
      "title": "27"
    }
  }), _c('h2', {
    staticClass: "int_niv1",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("Exodus 34:11-16")]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("After the dreadful lapse of chapter 32, when through the making and worshipping of the golden calf the covenanted people compromised themselves with the paganism rampant in the surrounding cultures, their relationship with God was at risk. But Moses interceded, and God renewed the covenant with assurances of his on-going presence in their journey to the promised land. As a token of covenant renewal, God instructed Moses to make two new stone tablets, replacing the ones Moses broke in disgust when he saw the debauchery in the camp of Israel. Moses ascended Mount Sinai again with the new tablets, where the Lord revealed himself with a glorious declaration of his moral perfections and of his commitment to the covenant with fresh promises that he would demonstrate his power among his people.")]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("Now, in verses 11-16, the Lord declares what he expects from them in return. His commands flow logically out of both his own nature and their recent flirtation with bull worship. They are intended to immunize Israel against the infection of nature religion, to which the people had exposed themselves. As the nation proceeds into the idolatrous surroundings of Canaanite civilization, their own recent behaviour does not encourage sanguine expectations. Without experience in agriculture, Israel will naturally turn to Canaanite practices for instruction. And if those practices, permeated with idolatry, seem to guarantee survival, the pressure on their faith to adapt to the local religion will be intense:"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/Text/appen10#NFIN33",
      "id": "ap_NFIN33-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6")])])]), _vm._v(" "), _c('div', {
    staticClass: "cita"
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_28",
      "title": "28"
    }
  }), _c('i', [_c('sup', [_vm._v("11")])]), _vm._v("Observe what I command you today. Behold, I will drive out before you the Amorites, the Canaanites, the Hittites, the Perizzites, the Hivites, and the Jebusites.")]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_ssalinea last"
  }, [_c('i', [_c('sup', [_vm._v("12")])]), _vm._v("Take care, lest you make a covenant with the inhabitants of the land to which you are going, lest they become a snare among you.")])]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("Verse 11 begins with a call to universal obedience, and verse 12 with a call to particular watchfulness."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/Text/appen10#NFIN34",
      "id": "ap_NFIN34-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7")])]), _vm._v(" After falling so readily into idolatry with the golden calf, Israel"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/Text/appen10#NFIN35",
      "id": "ap_NFIN35-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8")])]), _vm._v(" must never again be naïve about their bent toward moral and religious contamination from the surrounding peoples."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/Text/appen10#NFIN36",
      "id": "ap_NFIN36-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9")])]), _vm._v(" They must police themselves strictly. God, for his part, declares that he will drive out the pagan nations from the promised land, showing his opposition to the religious principles upon which their civilizations are based. How then can Israel, in covenant with a God of such commitments, make another covenant with the very nations he opposes?"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/Text/appen10#NFIN37",
      "id": "ap_NFIN37-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("10")])]), _vm._v(" The danger is that the paganism of these peoples – a real threat in view of the calf incident – would become a ‘snare’ among the people of God."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/Text/appen10#NFIN38",
      "id": "ap_NFIN38-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("11")])]), _vm._v(" Verse 13 implies what that snare is and specifies how this danger is to be avoided:")]), _vm._v(" "), _c('div', {
    staticClass: "cita"
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea last"
  }, [_c('i', [_c('sup', [_vm._v("13")])]), _vm._v("For you shall tear down their altars, and break their pillars, and cut down their Asherim "), _c('i', [_c('sup', [_vm._v("14")])]), _vm._v("(for you shall worship no other god, for the Lord, whose name is Jealous, is a jealous God), "), _c('i', [_c('sup', [_vm._v("15")])]), _vm._v("lest you make a covenant "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_29",
      "title": "29"
    }
  }), _vm._v("with the inhabitants of the land, and when they play the harlot after their gods and sacrifice to their gods and one invites you, you eat of his sacrifice, "), _c('i', [_c('sup', [_vm._v("16")])]), _vm._v("and you take wives from their daughters for your sons, and their daughters play the harlot after their gods and make your sons play the harlot after their gods.")])]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("According to verse 13, monuments of pagan worship deserve destruction. Ultimately, this is so because such forms of worship will distort Israel’s vision of who God is. But Yahweh’s purpose here is more proximate and immediately practical. These tangible emblems of pagan theology threaten to seduce Israel into compromise with pagan religious practice. The concern is that another golden calf or its equivalent could arise in Israel. That possibility will be precluded if Israel settles upon a determined policy of comprehensive destruction of such objects."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/Text/appen10#NFIN39",
      "id": "ap_NFIN39-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("12")])])]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("Verse 14a claims exclusivity for Yahweh in the hearts and devotion of the people as the rationale for the policy of verse 13."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/Text/appen10#NFIN40",
      "id": "ap_NFIN40-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("13")])]), _vm._v(" They are to worship no other God."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/Text/appen10#NFIN41",
      "id": "ap_NFIN41-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("14")])]), _vm._v(" And, in turn, the incentive for singularity of devotion to Yahweh is, according to verse 14b, his own nature. He is a jealous God. Indeed, his very name is Jealous."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/Text/appen10#NFIN42",
      "id": "ap_NFIN42-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("15")])]), _vm._v(" This is the language used in connection with the ‘law of jealousy’ in Numbers 5:11-31, instructing the "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_30",
      "title": "30"
    }
  }), _vm._v("community in what to do when a man is overwhelmed with a spirit of jealousy for his wife. "), _c('i', [_vm._v("Mutatis mutandis")]), _vm._v(", Yahweh’s jealousy for his wife Israel requires that she offer her devotion to no other lover, just as a man will share his wife with no other."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/Text/appen10#NFIN43",
      "id": "ap_NFIN43-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("16")])]), _vm._v(" The covenant creates a sacred boundary not to be encroached upon. It warrants a lawful sense of entitlement within God, which, when violated, generates intense emotional upheaval:"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/Text/appen10#NFIN44",
      "id": "ap_NFIN44-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("17")])])]), _vm._v(" "), _c('div', {
    staticClass: "cita"
  }, [_c('div', {
    staticClass: "stroplg"
  }, [_c('p', {
    staticClass: "verslg"
  }, [_vm._v("They "), _c('i', [_vm._v("stirred")]), _vm._v(" him "), _c('i', [_vm._v("to jealousy")]), _vm._v(" with strange gods;")]), _vm._v(" "), _c('p', {
    staticClass: "verslg type_1"
  }, [_vm._v("with abominable practices they "), _c('i', [_vm._v("provoked")]), _vm._v(" him "), _c('i', [_vm._v("to anger")])])]), _vm._v(" "), _c('div', {
    staticClass: "cita_source"
  }, [_vm._v("(Dt. 32:16, "), _c('span', {
    staticClass: "small"
  }, [_vm._v("RSV")]), _vm._v(").")])]), _vm._v(" "), _c('div', {
    staticClass: "cita"
  }, [_c('div', {
    staticClass: "stroplg"
  }, [_c('p', {
    staticClass: "verslg"
  }, [_vm._v("They have "), _c('i', [_vm._v("stirred")]), _vm._v(" me "), _c('i', [_vm._v("to jealousy")]), _vm._v(" with what is no god;")]), _vm._v(" "), _c('p', {
    staticClass: "verslg type_1"
  }, [_vm._v("They have "), _c('i', [_vm._v("provoked")]), _vm._v(" me with their idols")])]), _vm._v(" "), _c('div', {
    staticClass: "cita_source"
  }, [_vm._v("(Dt. 32:21, "), _c('span', {
    staticClass: "small"
  }, [_vm._v("RSV")]), _vm._v(").")])]), _vm._v(" "), _c('div', {
    staticClass: "cita"
  }, [_c('div', {
    staticClass: "stroplg"
  }, [_c('p', {
    staticClass: "verslg"
  }, [_vm._v("For they "), _c('i', [_vm._v("provoked")]), _vm._v(" him "), _c('i', [_vm._v("to anger with")]), _vm._v(" their high places;")]), _vm._v(" "), _c('p', {
    staticClass: "verslg type_1"
  }, [_vm._v("they "), _c('i', [_vm._v("moved")]), _vm._v(" him "), _c('i', [_vm._v("to jealousy")]), _vm._v(" with their graven images")])]), _vm._v(" "), _c('div', {
    staticClass: "cita_source"
  }, [_vm._v("(Ps. 78:58, "), _c('span', {
    staticClass: "small"
  }, [_vm._v("RSV")]), _vm._v(").")])]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("And ‘as his name is, so is he’ (Cassuto 1967: 444)."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/Text/appen10#NFIN45",
      "id": "ap_NFIN45-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("18")])]), _vm._v(" When the "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_31",
      "title": "31"
    }
  }), _vm._v("love of Jealous is offended, he burns."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/Text/appen10#NFIN46",
      "id": "ap_NFIN46-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("19")])]), _vm._v(" His love is not morally indifferent, pouring out its benefits heedless of human response."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/Text/appen10#NFIN47",
      "id": "ap_NFIN47-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("20")])]), _vm._v(" He expects and requires an ardent and faithful love in return."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/Text/appen10#NFIN48",
      "id": "ap_NFIN48-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("21")])])]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("Verses 15-16 resume the thought begun in verse 12 and elaborate upon the snare awaiting Israel in the promised land if they are incautious in their relations with the indigenous peoples. The danger is that, by incremental degrees, the covenanted people could be absorbed into paganism. Interestingly, the utterance begun at verse 11 could conceivably have concluded at the end of verse 14, followed by the equivalent to verse 17."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/Text/appen10#NFIN49",
      "id": "ap_NFIN49-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("22")])]), _vm._v(" The function of verses 15-16, then, is to amplify upon Yahweh’s concern to warn and protect his people. These verses imply that, even if the land is completely cleared of the institutional manifestations of idolatry, "), _c('i', [_vm._v("viz")]), _vm._v(". the altars, pillars and Asherim of verse 13, a danger still exists that the paganism they stand for could be renewed through friendly relations with the Canaanites who would retain a sense of affinity with and duty to their local gods."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/Text/appen10#NFIN50",
      "id": "ap_NFIN50-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("23")])]), _vm._v(" Those deep psychological attachments would endure after the desecration of their sanctuaries, so that the danger of immorality from paganism would continue.")]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("That danger unfolds by stages – first as a treaty of mutual advantage, then as an invitation to share in worship, then eating of a sacrifice made to a pagan god or goddess, and finally intermarriage with the Canaanites, with the result that all distinctions may in time be expected to dissolve. What begins as "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_32",
      "title": "32"
    }
  }), _vm._v("an agreement between friends eventuates in the extinction of Israel as a people uniquely covenanted to God."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/Text/appen10#NFIN51",
      "id": "ap_NFIN51-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("24")])])]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("Strikingly, these verses describe pagan worship as whoredom – an attractive whoredom easily capable of spreading its enticements to others. English idiom might lead one to expect the verb "), _c('span', {
    staticClass: "mev1"
  }, [_vm._v("√")]), _c('i', [_vm._v("znh")]), _vm._v(" ("), _c('span', {
    staticClass: "small"
  }, [_vm._v("RSV")]), _vm._v(", ‘play the harlot’) to be construed with a form of the preposition ‘with’ rather than ‘after’. But to ‘play the harlot "), _c('i', [_vm._v("after")]), _vm._v("’ pagan gods is to cultivate a relationship with them, to render unto them one’s obedience and devotion, to walk in their ways and pursue their ideals."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/Text/appen10#NFIN52",
      "id": "ap_NFIN52-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("25")])]), _vm._v(" The net force of the idiom is not unlike ‘to go/follow after’ other gods,"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/Text/appen10#NFIN53",
      "id": "ap_NFIN53-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("26")])]), _vm._v(" except that, marked by "), _c('span', {
    staticClass: "mev1"
  }, [_vm._v("√")]), _c('i', [_vm._v("znh")]), _vm._v(", the imagery is sexual rather than ambulatory because the larger controlling motif is marital.")]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("The force of this language in verse 15 does not assume covenantal status for the Ganaanite peoples, as if their ‘playing the harlot after their gods’ implied a legitimate but violated union with Yahweh, for the gods in view are ‘"), _c('i', [_vm._v("their")]), _vm._v(" gods’. Rather, verse 15 judges the moral character of their gods and the worship they require. The sense is very nearly – but not quite – literal, for pagan worship encouraged sexual immorality. But the expression remains figurative, for the language suggests that this whoredom is engaged in with the gods.")]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("That the local customs for worship should be insultingly condemned as whoredom arises presumably from two factors. First, the theology of the Canaanite peoples evidences a preoccupation with fertility, lifting up before worshippers a vision of various gods and goddesses as sexually active."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/Text/appen10#NFIN54",
      "id": "ap_NFIN54-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("27")])]), _vm._v(" Secondly, the ritual outworking of this theology reflected its vision of deity."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/Text/appen10#NFIN55",
      "id": "ap_NFIN55-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("28")])]), _vm._v(" By contrast, classical Yahwistic theology nowhere presents him as a sexual being calling for sexual participation in "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_33",
      "title": "33"
    }
  }), _vm._v("worship. His creation of human sexuality finds its lawful outlet in the union of marriage, as defined by Genesis 2:23-24.")]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("The Canaanite peoples ‘playing the harlot after their gods’, then, were plunging into a form of worship radically alien to Yahwism but highly congenial with the inner logic of their own theology. The real irony appears in verse 16, where this harlotry in relation to the local deities spreads through intermarriage into the covenant community of Israel. The expectation is that intermarriage will not convert and purify the Canaanites but the reverse; it will corrupt Israel. The marriages envisaged here, no doubt lawful as far as social convention is concerned, still entail whoredom, for human marriage is not ultimate. Israel has a prior commitment to a heavenly husband, who is jealous for the love of his people. It may be expected that intermarriage will import into Israel a blurring of the clear theological and moral distinctions which define the meaning of Yahwism. With the loss of a vivid sense of boundaries, such as make the very concept of marriage meaningful and special, harlotry with other gods is inevitable. This sharing of one’s faith, devotion and obedience with any other than Yahweh is, in his reckoning of things, whoredom.")]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("Exodus 34:11-16, therefore, lifts up before Israel a vision of Yahweh as one intensely jealous for the love of his people, with the corollary that their participation in foreign worship constitutes so repulsive a violation of the covenant that they reduce themselves thereby to the moral status of whores responding to the overtures of strangers.")])]), _vm._v(" "), _c('div', {
    staticClass: "niv1",
    attrs: {
      "id": "niv1-002"
    }
  }, [_c('h2', {
    staticClass: "int_niv1",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("Leviticus 17:7")]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("Levitical law was given to set Israel apart as a people holy to Yahweh, like a gown adorning a bride for her husband. The whole of their lives was to be marked by the one dominant consideration of holiness to Yahweh, even including the butchering of animals and misuse of the blood, as in chapter 17.")]), _vm._v(" "), _c('div', {
    staticClass: "cita"
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea last"
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_34",
      "title": "34"
    }
  }), _vm._v("So they shall no more slay their sacrifices for goat-demons, after whom they play the harlot.")])]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("Verses 3-6 of this chapter decree that any man who slaughters an ox, a lamb or a goat for personal consumption must first present the animal to the duly authorized priest at the tabernacle. It is to be, first and foremost, an offering to Yahweh. The blood and fat are to be given up in sacrifice to Yahweh before the man may take the rest for himself. The principle is that ‘All slaughter is sacrifice’ (Snaith 1967: 118). Disregarding this requirement brings bloodguilt upon a man,"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/Text/appen10#NFIN56",
      "id": "ap_NFIN56-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("29")])]), _vm._v(" the penalty for which is that the guilty party will be ‘cut off’ from his people."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/Text/appen10#NFIN57",
      "id": "ap_NFIN57-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("30")])]), _vm._v(" Verse 5 implies that the purpose for this ruling is to bring stricter official control to the people’s slaughtering of animals, so that everything is subsumed under the larger life purpose of devotion to Yahweh. Up to this point, the people have been sacrificing animals wherever they pleased in the open field. The personal, "), _c('i', [_vm._v("ad hoc")]), _vm._v(" nature of this worship expression has permitted abuses. That loophole is being closed by this law.")]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("Verse 7 explains the conditions which require this ruling. The people have a long-standing practice"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/Text/appen10#NFIN58",
      "id": "ap_NFIN58-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("31")])]), _vm._v(" of sacrificing animals out in the countryside, far removed from priestly supervision, where they have been offering their animals not to their rightful Lord but to, of all things, goat-demons."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/Text/appen10#NFIN59",
      "id": "ap_NFIN59-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("32")])]), _vm._v(" This practice must stop, for it "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_35",
      "title": "35"
    }
  }), _vm._v("involves the covenanted people in a whorish pursuit of false gods. Given that the people of God were sharing their worship with such loathsome idols, Yahweh’s charge of whoredom seems almost mild. The holy bride of Yahweh was cavorting with weird, perverse gods, of such a nature as to be identified with lusty goats.")])]), _vm._v(" "), _c('div', {
    staticClass: "niv1",
    attrs: {
      "id": "niv1-003"
    }
  }, [_c('h2', {
    staticClass: "int_niv1",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("Leviticus 20:4-6")]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("Leviticus 20 decrees the death penalty for various violations of holiness to Yahweh. In contrast to the moral chaos widely accepted in the nation which God is expelling from the promised land, Israel is to observe the distinctions entailed in God’s moral order. To transgress his boundaries is to deny one’s consecration to Yahweh, making one indistinguishable from those not covenanted to him, as if he had not bound Israel to himself at all. That would amount to a rejection of his beneficent rule and an attempt to destroy his name on the human scene. Hence, the severity of the penalties.")]), _vm._v(" "), _c('div', {
    staticClass: "cita"
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea last"
  }, [_c('i', [_c('sup', [_vm._v("4")])]), _vm._v("And if the people of the land do at all hide their eyes from that man, when he gives one of his children to Molech, and do not put him to death, "), _c('i', [_c('sup', [_vm._v("5")])]), _vm._v("then I will set my face against that man and against his family, and will cut them off from among their people, him and all who follow after him in playing the harlot after Molech ("), _c('span', {
    staticClass: "small"
  }, [_vm._v("RSV")]), _vm._v(").")])]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_36",
      "title": "36"
    }
  }), _vm._v("Verses 2-5 prescribe the death penalty for anyone, Israelite or resident outsider, who participates in the worship of Molech."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/Text/appen10#NFIN60",
      "id": "ap_NFIN60-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("33")])]), _vm._v(" Verse 4 even requires that one not at all"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/Text/appen10#NFIN61",
      "id": "ap_NFIN61-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("34")])]), _vm._v(" disregard Molech worship in someone else, for Yahweh will deal as severely with an unconcerned observer as with an actual participant."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/Text/appen10#NFIN62",
      "id": "ap_NFIN62-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("35")])]), _vm._v(" So no-one may touch Molech, and no-one may hesitate to confront another who does. Alternatively, verse 4 may insist that, if the people of the land"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/Text/appen10#NFIN63",
      "id": "ap_NFIN63-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("36")])]), _vm._v(" turn a blind eye to any Molech worship in their midst, God will himself execute the penalty and will extend it to the violator’s family as well. Whatever the exact force of verse 4 may be, however, it gives the whole community a strong incentive to guard against the encroachment of Molech worship into a nation holy to Yahweh.")]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("In verse 5 Yahweh repeats his threat of verse 3, declaring that the family of the Molech worshipper will also be cut off, doubtless because they would be the most likely to know of his idolatry and the least likely to expose it. But holiness to Yahweh takes priority over loyalty to family. Indeed, Yahweh declares that he will cut off ‘all who follow after him in playing the harlot after Molech’."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/Text/appen10#NFIN64",
      "id": "ap_NFIN64-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("37")])]), _vm._v(" The judgment, therefore, is not arbitrary. It covers "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_37",
      "title": "37"
    }
  }), _vm._v("only those who play the harlot after Molech. But it is comprehensive. It covers "), _c('i', [_vm._v("all")]), _vm._v(" those who play the harlot after Molech. The observances of Molech worship are like an infection which must not be allowed to spread at all into the body of Israel, for they are lethal to holiness.")]), _vm._v(" "), _c('div', {
    staticClass: "cita"
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea last"
  }, [_c('i', [_c('sup', [_vm._v("6")])]), _vm._v("If a person turns to mediums and spiritists, playing the harlot after them, I will set my face against that person and will cut him off from among his people.")])]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("The striking thing about verse 6 is that this harlotry does not involve the worship of false gods but the pursuit of false revelation through human agency. Consulting mediums and spiritists"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/Text/appen10#NFIN65",
      "id": "ap_NFIN65-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("38")])]), _vm._v(" also amounts to whoredom, because, like idolatry, resorting to their ministrations denies Yahweh’s all-sufficiency. Just as the counsels of a perfectly wise husband should be satisfying to a fair-minded wife, so Yahweh’s revelation in law, Urim and Thummim, prophetic word, and so on, should satisfy "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_38",
      "title": "38"
    }
  }), _vm._v("the questions and perplexities of his people. To seek revelation beyond his provision insinuates failure in him, exposes a prying resdessness in the covenant people and subjects them to compromising guidance from degraded sources.")])]), _vm._v(" "), _c('div', {
    staticClass: "niv1",
    attrs: {
      "id": "niv1-004"
    }
  }, [_c('h2', {
    staticClass: "int_niv1",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("Numbers 15:38-40")]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("After the mixed report of the spies, Israel’s refusal to trust God for the conquest of the promised land and then their own desperate attempt to move forward without his empowering presence (Nu. 13 – 14), the narrative pauses in chapter 15 for God graciously to decree: ‘Say to the people of Israel, When you come into the land you are to inhabit, which I give you…’ (verse 2). Although the present generation of adults must die under the frown of God, his purpose has not been frustrated and Israel will take the land. The rulings declared in chapter 15 are to mark the lives of the younger generation of conquerors.")]), _vm._v(" "), _c('div', {
    staticClass: "cita"
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea last"
  }, [_c('i', [_c('sup', [_vm._v("38")])]), _vm._v("Speak to the people of Israel, and tell them to make tassels on the corners of their garments throughout their generations, and to put upon the tassel of each corner a cord of blue; "), _c('i', [_c('sup', [_vm._v("39")])]), _vm._v("and it shall be to you a tassel to look upon and remember all the commandments of the Lord, to do them, not to follow after your own heart and your own eyes, after which you are playing the harlot, "), _c('i', [_c('sup', [_vm._v("40")])]), _vm._v("so that you may remember and do all my commandments, and be holy to your God.")])]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("The adorning of Israelite garments with blue embellishments on their tassels"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/Text/appen10#NFIN66",
      "id": "ap_NFIN66-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("39")])]), _vm._v(" was, like other Mosaic laws, an encouragement "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_39",
      "title": "39"
    }
  }), _vm._v("to perceive all of life, throughout one’s daily routine, with careful attention to the law of God. The forgetful outlook, heedless of the many ways in which God’s law filters down into the particularities of everyday life, does not remain neutral. It is led away according to the likes and dislikes, the merely personal sense of right and wrong, the prejudices and ignorance, of the wayward human heart,"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/Text/appen10#NFIN67",
      "id": "ap_NFIN67-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("40")])]), _vm._v(" involving one in harlotry. To prevent that outcome, this law required symbolic ornamentation upon Israelite clothing as a constant reminder of the relevance of God’s law to all of life."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/Text/appen10#NFIN68",
      "id": "ap_NFIN68-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("41")])]), _vm._v(" Such an outlook would dignify Israel as holy to God."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/Text/appen10#NFIN69",
      "id": "ap_NFIN69-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("42")])])]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("Verse 39 does not specify idol worship as the harlotry in view. Nothing in the passage requires so narrow a referent."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/Text/appen10#NFIN70",
      "id": "ap_NFIN70-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("43")])]), _vm._v(" This ambiguity has the positive exegetical function of broadening the field of reference to all the wayward desires of the heart and the lusts of the eyes. The language concerns Israel’s ‘playing the harlot’ after their own hearts and eyes, implying without limitation the various temptations which may be imagined, perceived and caressed through the senses. But the law calls Israel both to deny what may seem right and expedient to oneself and to obey Yahweh even when the final outcome cannot be foreseen and assessed from a merely human perspective. Israel must trust Yahweh to be wiser than Israel in "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_40",
      "title": "40"
    }
  }), _vm._v("all the decrees of his law. The net force of the declaration is that all the sinful preferences of the autonomous self, running contrary to the law of God, are a kind of whoredom, as if Yahweh’s wisdom and ways were untrustworthy, with the result that his law would have to be supplemented out of one’s own notions. Such an elevation of the sensate over the spiritual, of the whimsical over the authoritative, violates Israel’s espousals to Yahweh.")])]), _vm._v(" "), _c('div', {
    staticClass: "niv1",
    attrs: {
      "id": "niv1-005"
    }
  }, [_c('h2', {
    staticClass: "int_niv1",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("Deuteronomy 31:16")]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("In the course of the Deuteronomic covenant, chapters 31 – 34 set forth the succession arrangements, ensuring the perpetuity of Yahweh’s rule over Israel after the death of Moses."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/Text/appen10#NFIN71",
      "id": "ap_NFIN71-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("44")])]), _vm._v(" When Joshua is presented as Moses’ successor, Yahweh calls Moses to make one last declaration to the people. He is to teach them the song recorded in chapter 32 as a blunt reminder to them of, their guilt before God, when in subsequent generations they fall away from him. Yahweh introduces this final task by informing Moses of the nation’s future prospects:")]), _vm._v(" "), _c('div', {
    staticClass: "cita"
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea last"
  }, [_vm._v("And the L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ORD")]), _vm._v(" said to Moses, ‘Behold, you are about to sleep with your fathers; then this people will rise and play the harlot after the foreign gods in their midst, the gods of the land into which they are going, and they will forsake me and break my covenant which I have made with them.’")])]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("After Moses’ restraining influence is removed, Israel will seize the opportunity"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/Text/appen10#NFIN72",
      "id": "ap_NFIN72-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("45")])]), _vm._v(" to fulfill their desire for higher tolerance levels in their religious faith."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/Text/appen10#NFIN73",
      "id": "ap_NFIN73-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("46")])]), _vm._v(" It is as if they are itching to try out the "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_41",
      "title": "41"
    }
  }), _vm._v("new gods in the land to which they are going,"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/Text/appen10#NFIN74",
      "id": "ap_NFIN74-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("47")])]), _vm._v(" for new surroundings offer new opportunities. But as they broaden the range of worship acceptable to themselves, Yahweh judges them to be harlots, abandoning their rightful husband and violating the sacred bond which unites them.")])]), _vm._v(" "), _c('div', {
    staticClass: "niv1",
    attrs: {
      "id": "niv1-006"
    }
  }, [_c('h2', {
    staticClass: "int_niv1",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("Judges 2:16-17")]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("The author of Judges puts forward in summary form, in 2:6 – 3:6, the outstanding marks of Israel’s history during this period – the cycle of apostasy, oppression, repentance and deliverance. Thus, the spiritual harlotry cited in 2:17 does not record merely a single episode but rather describes the character of the times.")]), _vm._v(" "), _c('div', {
    staticClass: "cita"
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea last"
  }, [_c('i', [_c('sup', [_vm._v("16")])]), _vm._v("Then the L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ORD")]), _vm._v(" raised up judges, who saved them out of the power of those who plundered them. "), _c('i', [_c('sup', [_vm._v("17")])]), _vm._v("And they did not even listen to their judges, but they played "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_42",
      "title": "42"
    }
  }), _vm._v("the harlot after other gods and bowed down to them; they soon turned aside from the way in which their fathers had walked, who had obeyed the commandments of the L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ORD")]), _vm._v(", and they did not follow their example.")])]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("The connection between verses 16 and 17 seems to be one of astonishment. In the face of concrete evidences of Yahweh’s power to deliver his people through the judges, still Israel did not remain in a listening frame of mind once the deliverance was effected."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/Text/appen10#NFIN75",
      "id": "ap_NFIN75-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("48")])]), _vm._v(" On the contrary,"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/Text/appen10#NFIN76",
      "id": "ap_NFIN76-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("49")])]), _vm._v(" their wont was to renew the pursuit of their illegitimate, indeed discredited, lovers, who took the forms of the popular gods of their defeated oppressors. They entered into the pagan cultus, bowing down to the false gods. They turned quickly"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/Text/appen10#NFIN77",
      "id": "ap_NFIN77-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("50")])]), _vm._v(" – implying a genuine affection for the gods of Canaan and a correspondingly low estimate of Yahweh’s worth – away from the comparative faithfulness of their forefathers (verse 7).")]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("Judges 2:17 makes a similar point to Deuteronomy 31:16, except that the latter projects its vision out into the future while the former looks back through this era to highlight the recurring cycle of events. The whoredom of the nation was perceived clearly in advance, and the actual course of events vindicated the prediction. The unfolding Old Testament story presents, therefore, not an isolated incident of whoredom here and there but a clearly evident pattern in Israel’s behaviour, revealing a persistent unfaithfulness within.")])]), _vm._v(" "), _c('div', {
    staticClass: "niv1",
    attrs: {
      "id": "niv1-007"
    }
  }, [_c('h2', {
    staticClass: "int_niv1",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("Judges 8:27, 33")]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("After his extraordinary victory over the Midianites, Gideon "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_43",
      "title": "43"
    }
  }), _vm._v("could have ruled the nation. And he did not even have to conspire for power. The people offered it to him. But he refused, asking for something else instead, something inspired not by political ambition but by misguided religious zeal. He asked for the golden earrings confiscated, among other things, as spoil from the defeated Midianites.")]), _vm._v(" "), _c('div', {
    staticClass: "cita"
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea last"
  }, [_c('i', [_c('sup', [_vm._v("27")])]), _vm._v("And Gideon made an ephod of it and put it in his city, in Ophrah; and all Israel played the harlot after it there, and it became a snare to Gideon and to his family ("), _c('span', {
    staticClass: "small"
  }, [_vm._v("RSV")]), _vm._v(").")])]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("The period of the judges was infamous for its widespread moral confusion. ‘Every man did what was right in his own eyes’ (21:25), and not even Gideon escaped the spirit of the times. Rather than respect the unique prerogatives of the Levites at the tabernacle in Shiloh, Gideon made his own personal ephod in Ophrah. As a device for enquiring of God,"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/Text/appen10#NFIN78",
      "id": "ap_NFIN78-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("51")])]), _vm._v(" an ephod may have offered Gideon not only constant access to personal guidance – something upon which he had relied more than once in the course of his leadership"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/Text/appen10#NFIN79",
      "id": "ap_NFIN79-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("52")])]), _vm._v(" – but also perhaps informal authority as a man made privy to the counsels of God. He may have even worn the ephod at times himself."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/Text/appen10#NFIN80",
      "id": "ap_NFIN80-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("53")])]), _vm._v(" Whatever his motives may have been,"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/Text/appen10#NFIN81",
      "id": "ap_NFIN81-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("54")])]), _vm._v(" however, the consequence was plain. The ephod, "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_44",
      "title": "44"
    }
  }), _vm._v("outside its proper context and separated from the teaching ministry of the priests, seems to have attracted to itself the superstitions of the folk theology common among the people, so that they treated it with misplaced veneration, as if it were a pagan charm. They trusted in it rather than in Yahweh and neglected his formally established means of grace. And for Gideon himself and his household (who doubtless followed his example), it became a snare entangling them in yet further sins, unspecified in the text.")]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("The arresting aspect of this episode is that a good man, presumably intending to do good, in grateful response to a divine victory, inadvertently leads the people of God into whoredom. And the object being lavished with affection is not a vulgar Asherah pole but a ritual object legitimate within the duly authorized Israelite cultus."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/Text/appen10#NFIN82",
      "id": "ap_NFIN82-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("55")])]), _vm._v(" Not only is Israel capable of allowing Canaanite religion to steal its way into their hearts, they are also capable of reinterpreting the inner meaning of Yahwism so that the revealed religion is virtually Canaanized. Their accommodation can move both ways, but always to the detriment of faithfulness to Yahweh.")]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("The linguistic formula for harlotry in this text – no different from, say, Exodus 34:16, where foreign gods are in view – encourages the presumption that, in the minds of the people, the ephod might as well have been an image of Baal, so unreasoning were they. Spiritual whoredom does not require that the object of devotion be foreign in nature. It may be Yahwistic. The whoredom consists in the psychology of the worshipper; it is not necessarily inherent in the outward object.")]), _vm._v(" "), _c('div', {
    staticClass: "cita"
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea last"
  }, [_c('i', [_c('sup', [_vm._v("33")])]), _vm._v("As soon as Gideon died, the people of Israel turned back and played the harlot after the Baals, and made Baal-berith their god.")])]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("With a readiness which revealed their true affections, Israel apostatized"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/Text/appen10#NFIN83",
      "id": "ap_NFIN83-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("56")])]), _vm._v(" upon their leader’s death, whoring after the local fertility gods of Canaan. Evidently, they ascribed special status to a certain ‘Lord of the covenant’ (Baal-berith), whose temple was "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_45",
      "title": "45"
    }
  }), _vm._v("located at Shechem (Jdg. 9:4)."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/Text/appen10#NFIN84",
      "id": "ap_NFIN84-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("57")])]), _vm._v(" That this particular Baal had associations in some sense with the concept of covenant is doubtless significant. Israel affirmed and reaffirmed the covenant with Yahweh at Shechem."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/Text/appen10#NFIN85",
      "id": "ap_NFIN85-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("58")])]), _vm._v(" Perhaps this is what attracted the Israelites to Baal-berith, for there may have seemed to be common ground between their ancestral faith and the indigenous religion. Whether that common ground was only apparent on the surface or manifested a true inner coherence was a question apparently lost upon the undiscerning Israelites. One wonders if they took comfort in the thought that here was a Baal truly congenial with their covenant faith. Yahweh must have felt flattered.")]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("It is significant that the clearest marital images early in the story of the covenanted people are Israel’s whoredom and Yahweh’s jealousy in return. From the beginning, the marriage was strained. That tension will break out into open conflict in the prophetic literature.")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2c31608e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/chap2.vue
// module id = 81
// module chunks = 0